import styles from './QuotesModule.module.scss';

import quotesMark from 'images/icons/quotes_mark.svg';

import type { ReferencedEntry } from 'contentful';
import React from 'react';

import type { QuotesAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { Image } from 'components/Image/Image';
import { isEntry } from 'utils/EntryUtil';

interface IQuotesModuleProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<QuotesAssembly>;
}

const QuotesModule: React.FunctionComponent<IQuotesModuleProps> = (props: IQuotesModuleProps) => {
  const { entry, ...others } = props;

  if (!isEntry(entry)) return null;

  const { quote, merchantName, businessName } = entry.fields;

  return (
    <section className={styles.moduleWrapper} {...others}>
      <div className={styles.quotesModule}>
        <Image src={quotesMark} className={styles.quotesMark} aria-hidden />
        {quote && <h4 className={styles.quote}>{quote}</h4>}
        {merchantName && <p className={styles.merchantName}>{merchantName}</p>}
        {businessName && <p>{businessName}</p>}
      </div>
    </section>
  );
};

export { QuotesModule };
